var map = {
	"./accounting-account-balance-spreadsheet.svg": "a9cf",
	"./accounting-annual-tax.svg": "e9a2",
	"./accounting-balance-sheet.svg": "bbfa",
	"./accounting-business-tax.svg": "038c",
	"./accounting-general-ledger.svg": "cba8",
	"./accounting-personal-services-tax.svg": "e129",
	"./accounting-relation-setting.svg": "2330",
	"./accounting-setting.svg": "707cd",
	"./accounting-statement.svg": "423e3",
	"./accounting-summary.svg": "b575",
	"./accounting-voucher-list.svg": "0364",
	"./accounting-yearly-management.svg": "44c8",
	"./analysis-cash.svg": "a1f9",
	"./analysis-comparison.svg": "8363",
	"./analysis-deposit.svg": "690c",
	"./analysis-estimate-profit.svg": "bb6d",
	"./analysis-income-statement.svg": "d611",
	"./analysis-income.svg": "97fb",
	"./analysis-overview.svg": "e170",
	"./analysis-payout.svg": "24a4",
	"./analysis-vendor.svg": "5749",
	"./application-form-management.svg": "8304",
	"./audit-flow.svg": "36a1",
	"./bank-account.svg": "4cc3",
	"./company-info.svg": "7f9f",
	"./currency.svg": "00fa",
	"./current-expenditure.svg": "3fb0",
	"./default.svg": "fc7f",
	"./department.svg": "5b8d",
	"./financial-analysis.svg": "c4f9",
	"./invoice-serial-number.svg": "7378",
	"./loan-management.svg": "94e6",
	"./outsourcing-type.svg": "7abd",
	"./outsourcing.svg": "1679",
	"./payment-calendar.svg": "e2fe",
	"./petty-cash.svg": "d82c",
	"./project-accounting-balance-sheet.svg": "ec1d",
	"./project-accounting-statement.svg": "da06",
	"./project-type.svg": "6cac",
	"./project.svg": "6a3a",
	"./reimbursement-invoice.svg": "c3c6",
	"./remittances.svg": "b4e9",
	"./revenue-goal.svg": "c0cc",
	"./salary.svg": "bb2b",
	"./special-disbursement-project.svg": "7f19",
	"./staff-roles.svg": "c52e",
	"./staff.svg": "d549",
	"./tax-credit-invoice.svg": "5da7",
	"./trade-statement.svg": "e556",
	"./variable-statement.svg": "bee1",
	"./vendor.svg": "aa134"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b969";